import React, { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
export const EXPORT_NOTICE = 'A copy of public records. Not a finding, rating, or recommendation.';

export function BreachExportButton({ kypaId }) {
  const [busy, setBusy] = useState(false);
  const [sha, setSha] = useState(null);
  const [err, setErr] = useState(null);
  const download = async () => {
    setBusy(true); setErr(null);
    try {
      const r = await fetch(`${API}/api/kypa/breach-records/export/${encodeURIComponent(kypaId)}`, { cache: 'no-store' });
      if (!r.ok) throw new Error('Download failed');
      const blob = await r.blob();
      setSha(r.headers.get('X-Content-SHA256'));
      const a = Object.assign(document.createElement('a'), { href: URL.createObjectURL(blob), download: `kypa-public-records-${kypaId}.json` });
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };
  return (
    <div className="mt-4 rounded-xl border border-white/10 bg-white/[0.02] p-4" data-testid="breach-export">
      <button type="button" onClick={download} disabled={busy} className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-semibold text-white hover:border-white/40 transition-colors disabled:opacity-50" data-testid="breach-export-button">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />} Download public record (JSON)
      </button>
      <p className="text-[11px] text-gray-400 mt-3 leading-relaxed" data-testid="breach-export-notice">{EXPORT_NOTICE} Kojiru does not sign or vouch for this file. Check each record against its own source link or transaction.</p>
      <p className="text-[11px] text-gray-500 mt-1" data-testid="breach-export-corrections">Corrections: <a href="mailto:wayne@kojiru.com" className="underline hover:text-white">wayne@kojiru.com</a> with the record id.</p>
      {sha && <p className="text-[10px] text-gray-500 mt-2 font-mono break-all" data-testid="breach-export-sha">SHA-256 (recompute steps inside the file): {sha}</p>}
      {err && <p className="text-[11px] text-red-300 mt-2" data-testid="breach-export-error">{err}</p>}
    </div>
  );
}
